import React from 'react';

const AuthError = ({ error }) => {
  return <h3>Authentication error occurred: {error.errorCode}</h3>;
};

export default AuthError;
